// extracted by mini-css-extract-plugin
module.exports = {"addons":"Addons_addons__2cFeR","addonTitle":"Addons_addonTitle__15srX","addonDescription":"Addons_addonDescription__3A8sp"};